import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

type ThemeMode = 'light' | 'dark';

interface ThemeContextType {
    mode: ThemeMode;
    toggleColorMode: () => void;
}

const ThemeContext = createContext<ThemeContextType>({
    mode: 'light',
    toggleColorMode: () => { },
});

export const useTheme = () => useContext(ThemeContext);

interface ThemeProviderProps {
    children: ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
    // Initialize theme from localStorage or default to light
    const [mode, setMode] = useState<ThemeMode>(() => {
        const savedMode = localStorage.getItem('themeMode');
        return (savedMode === 'dark' ? 'dark' : 'light') as ThemeMode;
    });

    // Toggle between light and dark modes
    const toggleColorMode = () => {
        setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
    };

    // Update localStorage when theme changes
    useEffect(() => {
        localStorage.setItem('themeMode', mode);
    }, [mode]);

    const value = {
        mode,
        toggleColorMode,
    };

    return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}; 